import {
    InsuranceProviderDetails,
    InsuranceProviderPayload
} from "../maintenance-insurance-providers-interface/maintenance-insurance-providers.interface";

export class MaintenanceInsuranceProvidersModel {

    private pias_rep_code!: string;
    private responsedata!: InsuranceProviderDetails[];
    private insurance_provider!: InsuranceProviderPayload[];
    private id!: number;

    constructor() { }


    // Pias Rep Code

    getPiasRepCode(): string {
        return this.pias_rep_code;
    }

    setPiasRepCode(pias_rep_code: string) {
        this.pias_rep_code = pias_rep_code;
    }

    // Response Data (GET — Insurance Providers)

    getResponseData(): InsuranceProviderDetails[] {
        return this.responsedata;
    }

    setResponseData(responsedata: InsuranceProviderDetails[]) {
        this.responsedata = responsedata;
    }

    // Insurance Provider (POST payload)

    getInsuranceProvider(): InsuranceProviderPayload[] {
        return this.insurance_provider;
    }

    setInsuranceProvider(insurance_provider: InsuranceProviderPayload[]) {
        this.insurance_provider = insurance_provider;
    }

    // Id (DELETE payload)

    getId(): number {
        return this.id;
    }

    setId(id: number) {
        this.id = id;
    }


    // GET Request Payload

    toString() {
        return JSON.stringify({
            pias_rep_code: this.getPiasRepCode()
        });
    }

    // POST Request Payload

    toSavePayloadString() {
        return JSON.stringify({
            pias_rep_code: this.getPiasRepCode(),
            insurance_provider: this.getInsuranceProvider()
        });
    }

    // DELETE Request Payload

    toDeletePayloadString() {
        return JSON.stringify({
            id: this.getId()
        });
    }

}